module.exports = __webpack_public_path__ + "img/267-4.f950ccba.jpg";